module.exports = __webpack_public_path__ + "static/media/sg8tj93.296d8ba2.png";